import React from "react"
import "../../css/Spinner.css"

function Spinner({ centerVertical, color }: { centerVertical?: boolean; color?: string }) {
  let classes = "lds-ring"
  if (centerVertical) {
    classes = classes + " spinnerCenterVertical"
  }

  return (
    <div className={classes}>
      <div style={{ borderTopColor: color }}></div>
      <div style={{ borderTopColor: color }}></div>
      <div style={{ borderTopColor: color }}></div>
      <div style={{ borderTopColor: color }}></div>
    </div>
  )
}

export default Spinner
